module.exports = __webpack_public_path__ + "img/processing.4697b236.svg";